import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const userListSlice = createSlice({
  name: 'userList',
  initialState,
  reducers: {
    upsertUsers: (state, action) => {
      const payload = action.payload;
      if (!payload || typeof payload !== 'object') return;
      Object.keys(payload).forEach((id) => {
        if (payload[id] && typeof payload[id] === 'object') {
          state[id] = { ...(state[id] || {}), ...payload[id] };
        }
      });
    },
    clearUsers: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase('WORKKARD_USER_LIST_SUCCESS', (state, action) => {
      const payload = action.payload;
      if (!payload || typeof payload !== 'object') return;
      Object.keys(payload).forEach((id) => {
        if (payload[id] && typeof payload[id] === 'object') {
          state[id] = { ...(state[id] || {}), ...payload[id] };
        }
      });
    });
  },
});

export const { upsertUsers, clearUsers } = userListSlice.actions;

export const selectUserList = (state) => state.userList;
export const selectUserById = (id) => (state) =>
  (id != null && state.userList ? state.userList[id] : undefined);

export default userListSlice.reducer;
